import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

/**
 * Display an html representation of code
 * with an optional copy-to-clipboard button.
 * @author Will Davis <will.davis@mtna.us>
 */
@Component({
  selector: 'rds-code-snippet',
  template: `
    <div class="rds-code-snippet-container">
      <button
        *ngIf="clipboardCode"
        class="rds-code-snippet-copy-button"
        mat-icon-button
        [cdkCopyToClipboard]="clipboardCode"
        [matTooltip]="clipboardTooltip"
        (cdkCopyToClipboardCopied)="showCopyConfirmation()"
      >
        <mat-icon>content_copy</mat-icon>
      </button>
      <section class="rds-code-snippet-scroll-container">
        <code [innerHTML]="html"></code>
      </section>
    </div>
  `,
  styles: [
    `
      rds-code-snippet .rds-code-snippet-container {
        display: flex;
        min-height: 100%;
        position: relative;
      }
      rds-code-snippet .rds-code-snippet-scroll-container {
        box-sizing: border-box;
        overflow: auto;
        /* 56 to create extra scroll space for the copy button */
        padding: 16px 56px 16px 16px;
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
      }
      rds-code-snippet .rds-code-snippet-copy-button {
        position: absolute;
        right: 8px;
        top: 8px;
        z-index: 2;
        border-width: 1px;
        border-style: solid;
        line-height: 38px;
      }
      rds-code-snippet code {
        display: inline-block;
        font-family: 'Roboto Mono', monospace;
        line-height: 1.5;
        tab-size: 2;
        white-space: pre;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class RdsCodeSnippetComponent {
  /** Raw html to insert */
  @Input() html: string;
  /** Optional version of the code to copy to the clipboard */
  @Input() clipboardCode: string;
  /** Tooltip message for copy to clipboard buton, defaults to 'Copy the code' */
  @Input() clipboardTooltip = 'Copy the code';

  constructor(private snackBar: MatSnackBar) {}

  showCopyConfirmation() {
    this.snackBar.open('Copied to your clipboard successfully!', 'Dismiss', { duration: 3000 });
  }
}
